const emailErrorsTypes = {
  CONFIRMATION_EMAIL: {
    description: 'Confirmation email link expired',
    name: 'Confirmation Email',
  },
  RESET_PASSWORD: {
    description: 'Reset password link expired',
    name: 'Reset Password',
  },
};

export default emailErrorsTypes;



// WEBPACK FOOTER //
// ./src/data/static/emailErrorsTypes.js